import { useStore } from '@/lib/store';

const styles = [
  {
    id: 'modern',
    name: 'Modern',
    description: 'Clean, minimalist design with plenty of whitespace',
    preview: 'bg-gradient-to-br from-gray-50 to-gray-100',
  },
  {
    id: 'classic',
    name: 'Classic',
    description: 'Professional, balanced layout with traditional elements',
    preview: 'bg-gradient-to-br from-blue-50 to-indigo-100',
  },
  {
    id: 'bold',
    name: 'Bold',
    description: 'Striking visuals with high contrast and impactful design',
    preview: 'bg-gradient-to-br from-purple-100 to-pink-100',
  },
] as const;

export function StepTwo() {
  const { formData, setFormData } = useStore();

  return (
    <div className="space-y-6 animate-in">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Choose your style</h2>
        <p className="text-gray-600">Select a design direction and customize your colors.</p>
      </div>

      <div>
        <label className="label mb-3">Design Style <span className="text-red-500">*</span></label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {styles.map((style) => (
            <button
              key={style.id}
              type="button"
              className={`
                card-hover text-left p-4 transition-all
                ${formData.style === style.id
                  ? 'ring-2 ring-primary-500 border-primary-500'
                  : ''
                }
              `}
              onClick={() => setFormData({ style: style.id })}
            >
              <div className={`h-24 rounded-lg mb-3 ${style.preview}`} />
              <h3 className="font-semibold text-gray-900">{style.name}</h3>
              <p className="text-sm text-gray-500 mt-1">{style.description}</p>
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="primaryColor" className="label">
            Primary Color
          </label>
          <div className="flex items-center space-x-3">
            <input
              type="color"
              id="primaryColor"
              className="w-12 h-12 rounded-lg border-2 border-gray-200 cursor-pointer"
              value={formData.primaryColor || '#3f51b5'}
              onChange={(e) => setFormData({ primaryColor: e.target.value })}
            />
            <input
              type="text"
              className="input flex-1"
              value={formData.primaryColor || '#3f51b5'}
              onChange={(e) => setFormData({ primaryColor: e.target.value })}
              placeholder="#3f51b5"
            />
          </div>
        </div>

        <div>
          <label htmlFor="secondaryColor" className="label">
            Secondary Color
          </label>
          <div className="flex items-center space-x-3">
            <input
              type="color"
              id="secondaryColor"
              className="w-12 h-12 rounded-lg border-2 border-gray-200 cursor-pointer"
              value={formData.secondaryColor || '#ff4081'}
              onChange={(e) => setFormData({ secondaryColor: e.target.value })}
            />
            <input
              type="text"
              className="input flex-1"
              value={formData.secondaryColor || '#ff4081'}
              onChange={(e) => setFormData({ secondaryColor: e.target.value })}
              placeholder="#ff4081"
            />
          </div>
        </div>
      </div>

      <div className="p-4 rounded-lg border-2 border-dashed border-gray-200 bg-gray-50">
        <p className="text-sm text-gray-600 text-center">
          Color Preview
        </p>
        <div className="flex justify-center space-x-4 mt-3">
          <div
            className="w-16 h-16 rounded-lg shadow-sm"
            style={{ backgroundColor: formData.primaryColor || '#3f51b5' }}
          />
          <div
            className="w-16 h-16 rounded-lg shadow-sm"
            style={{ backgroundColor: formData.secondaryColor || '#ff4081' }}
          />
        </div>
      </div>
    </div>
  );
}
